module.exports = __webpack_public_path__ + "img/-e-photo_04@2x.f63f295f.png";